package com.ustadmobile.mui.common

import web.cssom.ident

object Area {
    val Header = ident("header")
    val Sidebar = ident("sidebar")
    val Content = ident("content")
}
